import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import { isSellerBrandingRemovalTestVariant } from 'dibs-buyer-layout/exports/sellerBrandingRemovalAbTestHelpers';
import {
    checkRewardedSeller,
    checkTradeUserUnderTopLevelLoyaltyTiers,
} from 'dibs-buyer-layout/exports/sellerBrandingHelpers';
import { useSbSelector } from '../../reducers/useSbSelector';
import { SharedStarRating } from '../../shared/SharedStarRating/SharedStarRating';

import dibsCss from 'dibs-css';
import styles from './SbSharedRelatedSeller.scss';

import { SbSharedRelatedSellerTitle_seller$key } from './__generated__/SbSharedRelatedSellerTitle_seller.graphql';
import { SbSharedRelatedSellerTitle_user$key } from './__generated__/SbSharedRelatedSellerTitle_user.graphql';

type Props = {
    seller: SbSharedRelatedSellerTitle_seller$key;
    user: SbSharedRelatedSellerTitle_user$key;
};

export const SbSharedRelatedSellerTitle: FC<Props> = ({ seller: sellerRef, user: userRef }) => {
    const seller = useFragment(
        graphql`
            fragment SbSharedRelatedSellerTitle_seller on Seller {
                ...SharedStarRating_seller
                ...sellerBrandingHelpers_seller
                sellerProfile {
                    company
                }
                shippingAddress {
                    displayCityStateCountry
                }
            }
        `,
        sellerRef
    );
    const user = useFragment(
        graphql`
            fragment SbSharedRelatedSellerTitle_user on User {
                ...sellerBrandingHelpers_user
            }
        `,
        userRef
    );

    const isClient = useSbSelector(state => state.relayVariables.variables.isClient);

    if (!isClient) {
        return (
            <div
                className={classnames(styles.title, dibsCss.wFull, dibsCss.hLarge, dibsCss.mbSmall)}
            />
        );
    }

    const isRewardsTier = checkRewardedSeller(seller);
    const isUnderTopLevelLoyaltyTiers = checkTradeUserUnderTopLevelLoyaltyTiers(user);

    const sellerName =
        !isSellerBrandingRemovalTestVariant() || isRewardsTier || isUnderTopLevelLoyaltyTiers ? (
            seller?.sellerProfile?.company
        ) : (
            <FormattedMessage
                id="SbSharedRelatedSeller.professionallyVetted.displayCityStateCountry"
                defaultMessage="Vetted Professional Seller in {displayCityStateCountry}"
                values={{
                    displayCityStateCountry: seller?.shippingAddress?.displayCityStateCountry,
                }}
            />
        );
    return (
        <>
            <div className={classnames(dibsCss.sassyFontHeaderMedium, dibsCss.mbSmall)}>
                {sellerName}
            </div>
            <div className={dibsCss.mbSmall}>
                <SharedStarRating seller={seller} />
            </div>
        </>
    );
};
